"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _throttle = _interopRequireDefault(require("lodash/throttle"));

var _preact = require("preact");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var Tracker = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(Tracker, _Component);

  var _super = _createSuper(Tracker);

  function Tracker(props) {
    var _this;

    (0, _classCallCheck2.default)(this, Tracker);
    _this = _super.call(this, props);
    _this.listener = (0, _throttle.default)(_this.listener.bind((0, _assertThisInitialized2.default)(_this)), 30);
    return _this;
  }

  (0, _createClass2.default)(Tracker, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      document.body.addEventListener('mousemove', this.listener);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.body.removeEventListener('mousemove', this.listener);
    }
  }, {
    key: "listener",
    value: function listener(e) {
      this.props.onMove(e.clientX, e.clientY);
    }
  }, {
    key: "render",
    value: function render() {
      return null;
    }
  }]);
  return Tracker;
}(_preact.Component);

exports.default = Tracker;